import { useDispatch, useSelector } from "react-redux"

import CheckboxCell from "../../../common/interactive/CheckboxCell"
import { caseActions } from "../../../../store/case"
import { caseQuickUpdate, updateFullNegotiatorsData } from "../../../../lib/fetchApi"
import { notificationActions } from "../../../../store/notifications"

const PrimaryCheckbox = ({data, label, folder, apiCase, propertyName}) => {
    const dispatch = useDispatch()

    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase) 

    const primaryInsuranceHandler = async (value) => {

        if (value.data.value) { // value is true, remove the other managing attorney
            let dispatchBody = {
                folder: folder,
                item: {
                    itemId: data.id,
                    field: propertyName,
                    value: value.data.value,
                },
                groupRelation: {
                    field: propertyName,
                    value: !value.data.value,
                }
            }
            console.log("dispatchBody", dispatchBody);
            dispatch(caseActions.modifyActiveCase(dispatchBody))

            if (apiCase == 'case_attorney') { // if its an attorney and we se the value to true, need to rebuild the negotiator data
                let negotiator = await updateFullNegotiatorsData(userToken, activeCase.case.id)

                if (negotiator && negotiator.errorMessage) {
                    dispatch(notificationActions.setError(negotiator))
                } else {
                    dispatch(caseActions.replaceWholeFolder({
                        folder: 'case_negotiation',
                        content: negotiator
                    }))
                }
            }

            if (apiCase == 'case_major_med') { // if major med need to set the billing order to 1
                let dispatchObj = {
                    folder: folder,
                    item: {
                        itemId: data.id,
                        field: 'billing_order',
                        value: 1,
                    }
                }
                let currentPrimary = activeCase.major_meds.find(item => item.is_primary_insurance)
                if (currentPrimary) {
                    dispatchObj.specificRelation = {
                        specificItemId: currentPrimary.id,
                        field: 'billing_order',
                        value: data.billing_order
                    }
                    await caseQuickUpdate(userToken, activeCase.case.id, {
                        type: 'case_major_med',
                        type_id: currentPrimary.id,
                        fields: {
                            billing_order: data.billing_order,
                        }
                    }, dispatch)
                }
                dispatch(caseActions.modifyActiveCase(dispatchObj))   
            }
        } 
   
        // dispatch(caseActions.modifyActiveCaseMultiple({
        //     folder: folder,
        //     item: {
        //         itemId: data.id,
        //         fields: [
        //             {
        //                 field: propertyName,
        //                 value: value.data.value
        //             },
        //         ]            
        //     }
        // }))
 
        // for (const element of activeCase[folder]) {
        //     if (element.id !== data.id) {
        //         if (element[propertyName]) {
        //             const removeBody = {
        //                 type: apiCase,
        //                 type_id: element.id,
        //                 fields: {
        //                     [propertyName]: false
        //                 }    
        //             }

        //             const update = await caseQuickUpdate(userToken, activeCase.case.id, removeBody, dispatch)
        //             if (update && update.errorMessage) {
        //                 dispatch(notificationActions.setError(update))
        //             }
        //         }
        //     }
        // }

        const body = {
            type: apiCase,
            type_id: data.id,
            fields: {
                [propertyName]: value.data.value
            }    
        }

        if (apiCase == 'case_major_med') { // if major med need to set the billing order to 1
            const MajorMedBillingbody = {
                type: apiCase,
                type_id: data.id,
                fields: {
                    billing_order: 1
                }    
            }
            await caseQuickUpdate(userToken, activeCase.case.id, MajorMedBillingbody, dispatch)            
        }

        const update = await caseQuickUpdate(userToken, activeCase.case.id, body, dispatch)

        if (update && update.errorMessage) {
            dispatch(notificationActions.setError(update))
        }    
        
    }

    return <CheckboxCell checked={data[propertyName]} label={label} name={'is_primary_insurance'} direction={'reverse'} action={primaryInsuranceHandler} isDisabled={data[propertyName]} identifier={{type: apiCase}}/>
}

export default PrimaryCheckbox